import { Component } from '@angular/core';

@Component({
  selector: 'app-small-fleet',
  templateUrl: './small-fleet.component.html',
  styleUrl: './small-fleet.component.css'
})
export class SmallFleetComponent {

}
